import { ModulesCtx } from "@dynamic/types";
import { createContext } from "react";

const PreloadedModulesCtx = createContext<ModulesCtx>({});
export { PreloadedModulesCtx };

const RegisterSSRModuleCtx = createContext<Set<string>>(new Set());
export { RegisterSSRModuleCtx };

export const viteReactLoadableApiKey = "__VITE_REACT_LOADABLE__";
